import React, { useState } from 'react';
import { IAssistantMessage } from '../../../types';
import { ChatMessage } from '../../message-box';
import { TextInputCard } from './TextInputCard';
import { ConfirmUpdateModal } from '../../ConfirmUpdateModal';

interface TextInputMessageBublesProps {
    message: IAssistantMessage;
    handleSubmit: (questionId: string, textValue: string) => void;
    updateSubmit: (questionId: string, textValue: string) => void;
    isProcessing?: boolean;
}

export const TextInputMessageBubles: React.FC<TextInputMessageBublesProps> = ({
    message,
    handleSubmit: handleSubmitProp,
    updateSubmit: updateSubmitProp,
    isProcessing = false,
}) => {
    const [showModal, setShowModal] = useState(false);
    const [pendingValue, setPendingValue] = useState<string>('');

    // Check if this question has already been answered
    const hasAnswer = message.response?.answer && message.response.answer.length > 0;

    const handleSubmit = (value: string) => {
        if (hasAnswer) {
            // Show confirmation modal before updating
            setPendingValue(value);
            setShowModal(true);
        } else {
            // New answer, proceed directly
            handleSubmitProp(message.question!.questionId, value);
        }
    };

    const handleConfirm = () => {
        if (pendingValue) {
            updateSubmitProp(message.question!.questionId, pendingValue);
        }
        setShowModal(false);
        setPendingValue('');
    };

    const handleCancel = () => {
        setShowModal(false);
        setPendingValue('');
    };

    const oldAnswerText = message.response?.answer?.[0]?.optionText || '';

    return (
        <div>
            <ChatMessage message={message} />
            <TextInputCard
                savedValue={message.response?.answer?.[0]?.optionText || ''}
                placeholder={message.question!.helperText || 'Enter your answer...'}
                onSubmit={handleSubmit}
                isDisabled={isProcessing}
            />
            <ConfirmUpdateModal
                visible={showModal}
                questionText={message.question!.question}
                oldAnswer={oldAnswerText}
                newAnswer={pendingValue}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
            />
        </div>
    );
}
